/* Smart recommendations for the cart and "Complete the set".
   The server renders hand-picked cards (data-source="pick") and same-category best sellers
   (data-source="category"). This script slots Shopify's automatic "related" picks between them,
   then trims the list back to data-limit, so category cards are the first to go. */
(function () {
  if (window.__smartRecs) return;
  window.__smartRecs = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function fill(box) {
    if (box.dataset.autoDone) return;
    box.dataset.autoDone = '1';
    var seed = box.dataset.seed;
    var limit = parseInt(box.dataset.limit, 10) || 4;
    var list = box.querySelector('[data-smart-recs-list]');
    if (!seed || !list || (parseInt(box.dataset.picks, 10) || 0) >= limit) return;

    var sectionId = box.dataset.style === 'cart' ? 'smart-recs-cart' : 'smart-recs-pdp';
    fetch(root + 'recommendations/products?product_id=' + encodeURIComponent(seed) +
          '&limit=10&intent=related&section_id=' + sectionId)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html || !box.isConnected) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var have = {};
        list.querySelectorAll('[data-rec-card]').forEach(function (c) { have[c.dataset.productId] = 1; });
        var picks = list.querySelectorAll('[data-rec-card][data-source="pick"]');
        var anchor = picks.length ? picks[picks.length - 1] : null;
        /* Only keep automatic picks from the same category as the item(s), so they stay on-topic. */
        var types = box.dataset.types || '';
        tmp.querySelectorAll('[data-rec-card]').forEach(function (c) {
          if (have[c.dataset.productId]) return;
          if (types && types.indexOf(',' + c.dataset.type + ',') < 0) return;
          have[c.dataset.productId] = 1;
          if (anchor) anchor.after(c); else list.insertBefore(c, list.firstChild);
          anchor = c;
        });
        var cards = list.querySelectorAll('[data-rec-card]');
        for (var i = cards.length - 1; i >= limit; i--) cards[i].remove();
      })
      .catch(function () {});
  }

  function run() { document.querySelectorAll('[data-smart-recs]').forEach(fill); }

  /* Cart: "+ Add another" on the 10% nudge raises the single line to 2 units. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-nudge-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    b.disabled = true;
    b.textContent = 'Adding…';
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: b.dataset.key, quantity: 2 })
    }).then(function () { location.reload(); }, function () { location.reload(); });
  });

  /* Product page: add a "Complete the set" item without leaving the page. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sl-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var label = b.textContent;
    b.disabled = true;
    b.textContent = 'Adding…';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.dataset.variantId), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        b.textContent = '✓ Added';
        b.classList.add('is-added');
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        /* Header cart badges (desktop + mobile) */
        document.querySelectorAll('[data-ct-cart-count], [data-ct-mobile-cart-count], .cart-count-bubble span[aria-hidden]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = false;
        });
        document.querySelectorAll('.ct-mobile-button--cart').forEach(function (a) { a.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items'); });
      })
      .catch(function () { b.disabled = false; b.textContent = label; });
  });

  run();
  /* The cart re-renders its section after every change; pick up the new list. */
  new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
})();
